<template>
	<CurvesPage class="curve" @onScale="drawLine">
		
		<!-- Название кривой -->
		
		<template #curveName>Астроида</template>
		
		<!-- модуль Характеристика кривой -->
		
		<template #curveFeature>
			
			<h5 class="mt-0">
				Геометрическое место точек:
			</h5>
			<img src="@/assets/img/astroid_gmt.gif" class="feature__gmt">
			<p class="feature__gmt">
				<strong>Астроида</strong>
				- плоская кривая, описываемая точкой окружности радиуса <vue-mathjax :formula="viewExpression('r')" class="formula"></vue-mathjax>, катящейся по внутренней стороне окружности радиуса <vue-mathjax :formula="viewExpression('R=4r')" class="formula"></vue-mathjax>.
				<br>
				Частный случай <a href="/hypocycloid">гипоциклоиды</a>.
			</p>
			
			<!-- Уравнение в полярных координатах -->
			
			<h5 class="mt-0">
				Полярное уравнение:
				<b-badge variant="light" class="curve__main-formula">
					<vue-mathjax
							:formula="equationInPolar"
							class="formula"
					></vue-mathjax>
				</b-badge>
			</h5>
			
			<!-- Уравнение в декартовых координатах -->
			
			<h5>Аналитическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationInCartesian"
						class="formula"
				></vue-mathjax>
			</p>
			
			<h5>Параметрическое уравнение:</h5>
			<p>
				<vue-mathjax
						:formula="equationParamInCartesian" class="formula"></vue-mathjax>
			</p>
			
			<!-- Область значений для параметра -->
			
			<h5 class="mt-0">Область значений <vue-mathjax :formula="parameterT" class="formula"></vue-mathjax>:</h5>
			
			<vue-slider
					v-model="t"
					:min="0"
					:max="2"
					:interval="0.1"
					@dragging="drawLine"
			></vue-slider>
			<p>
				<vue-mathjax :formula="rangeODZ" class="formula"></vue-mathjax>
			</p>
			
			<!-- Значения коэффициентов -->
			
			<h5>Зависимость от коэффициентов:</h5>
			
			<!-- Коэффициент a -->
			
			<label>
				<vue-mathjax :formula="coefficientA" class="formula"></vue-mathjax>:
			</label>
			
			<b-form-spinbutton v-model="a" min="0" max="20" step="1" @input="drawLine" vertical
			                   class="curve__coef"></b-form-spinbutton>
		
		</template>
		
		<!-- модуль Информация о кривой -->
		
		<!-- Изображение для модуля информации -->
		
		<template #curvePhoto>
			<a href="https://ru.wikipedia.org/wiki/%D0%9B%D0%B8%D1%82%D1%80%D0%BE%D0%B2,_%D0%99%D0%BE%D0%B7%D0%B5%D1%84_%D0%98%D0%BE%D0%B3%D0%B0%D0%BD%D0%BD"><img src="@/assets/img/lemniscata_info_bernoulli.jpg" width="100" alt="Йозеф Литров" class="info__picture"></a>
		</template>
		
		<!-- Контент -->
		
		<template #curveInfo>
			<h5>История:</h5>
			<p>
				Название кривой в форме «Astrois» предложил австрийский астроном <b><i>Йозеф Иоганн фон Литров в 1838 г.</i></b></p>
		</template>
		
		<!-- модуль Задачи -->
		
		<template #curveTasks>
			<h5 class="mb-4">Примеры задач:</h5>
			<b-media>
				<template #aside>
					<h6>1)</h6>
				</template>
				<h6 class="mt-0">Вычислить формулу длины дуги астроиды, используя параметрическое уравнение</h6>
				<b-button v-b-toggle.answer-1 variant="dark">Показать решение</b-button>
				<b-collapse id="answer-1" class="mt-2 answer">
					<p>1) Для решения задачи воспользуемся формулой длины дуги плоской кривой, заданной параметрически:
						<vue-mathjax
								:formula="viewExpression(' L = \\int_{t_{1}}^{t_{2}} \\sqrt { (x_{t}\')^{2} + (y_{t}\')^{2} dt } ')"
								class="formula"></vue-mathjax>;
						<br>
						2) Вычисляем данный интеграл:
						<vue-mathjax
								:formula="viewExpression(' L = \\int_{t_{1}}^{t_{2}} \\sqrt { (-3a \\cos^{2} t \\sin t)^{2} + (3a \\sin^{2} t \\cos t)^{2} } dt ')"
								class="formula"
						></vue-mathjax> = <vue-mathjax
								:formula="viewExpression(' 3a \\int_{t_{1}}^{t_{2}} \\sqrt { \\cos^{4} t \\sin^{2} t + \\sin^{4} t \\cos^{2} t  } dt ')"
								class="formula"
						></vue-mathjax> = <vue-mathjax
								:formula="viewExpression(' 3a \\int_{t_{1}}^{t_{2}} \\sqrt { \\sin^{2} t \\cos^{2} t (\\cos^{2} t  + \\sin^{2} t) } dt ')"
								class="formula"
						></vue-mathjax> = <vue-mathjax
								:formula="viewExpression(' 3a \\int_{t_{1}}^{t_{2}}  \\sin t \\cos t  dt ')"
								class="formula"
						></vue-mathjax> = <vue-mathjax
								:formula="viewExpression(' 3a \\int_{t_{1}}^{t_{2}} \\sin t d\\sin t ')"
								class="formula"
						></vue-mathjax> = <vue-mathjax
								:formula="viewExpression(' \\frac{3}{2} a (\\sin^{2} t_{2} - \\sin^{2} t_{1})')"
								class="formula"
						></vue-mathjax>
						
						<br>
						<b><i>Ответ</i></b>:
						<vue-mathjax
								:formula="viewExpression(' L = \\frac{3}{2} a (\\sin^{2} t_{2} - \\sin^{2} t_{1})')"
								class="formula"
						></vue-mathjax>
					</p>
				</b-collapse>
			</b-media>
		</template>
	
	</CurvesPage>
</template>

<script>
	import CurvesPage, { CurvesInterface } from '@/views/templates/CurvesPage';
	
	export default {
		name: 'LemniscataBernoulli',
		mixins: [CurvesInterface],
		data () {
			return {
				/* Коэффициенты уравнения */
				a: 0,
				/* ОДЗ параметра */
				t: [0, 2]
			}
		},
		computed: {
			/* Функции для представления в latex
			 * equationInPolar - Уравнение в полярных координатах
			 * equationInCartesian - Уравнение в декартовых координатах
			 * equationParamInCartesian - Параметрическое уравнение
			  * */
			equationInPolar: () => {
				return '$$ r = a \\sqrt { \\cos^{6} \\theta + sin^{6} \\theta} $$';
			},
			equationInCartesian: () => {
				return '$$ x^{ \\frac{2}{3} } +  y^{ \\frac{2}{3} } = a^{ \\frac{2}{3} } $$';
			},
			equationParamInCartesian: () => {
				return '$$ \\begin{cases} x = a \\cos^{3} t \\\\ y = a \\sin^{3} t \\end{cases}$$';
			},
			/* Свойство ОДЗ */
			rangeODZ: (context) => {
				return '$$ ' + context.t[0] +  ' \\pi < t <' + context.t[1] + ' \\pi $$';
			},
			maxTheta: ({ t }) => {
				return t[1] * Math.PI;
			},
			minTheta: ({ t }) => {
				return t[0] * Math.PI;
			}
		},
		methods: {
			/**
			 * Возвращает значение x при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			X (t) {
				return 160 + (this.a * Math.pow(Math.cos(t), 3)) * this.$store.state.step;
			},
			/**
			 * Возвращает значение y при заданном параметре
			 * @param {number} t
			 * @return {number}
			 */
			Y (t) {
				return 160 + (this.a * Math.pow(Math.sin(t), 3)) * this.$store.state.step;
			}
		},
		components: {
			CurvesPage
		}
	}
</script>

<style scoped lang="scss">

</style>
